exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._111TEJbeVRNNDnReUegPi {\n  display: flex;\n  flex-direction: column;\n  border-radius: .5rem;\n  padding: 0.5rem;\n  background-color: #f7f7f7;\n  word-break: break-all;\n}\n\n._4lhPTDVpRcjR-zCyIZd74 {\n  margin-left: .5rem;\n}\n._4lhPTDVpRcjR-zCyIZd74:first-of-type {\n  margin-left: 0;\n}\n.skhobjNWSuMbF_TEiUyBq {\n  margin-right: 5px;\n}", ""]);
// Exports
exports.locals = {
	"Cell": "_111TEJbeVRNNDnReUegPi",
	"checkboxLabel": "_4lhPTDVpRcjR-zCyIZd74",
	"checkbox": "skhobjNWSuMbF_TEiUyBq"
};